<template>
    <div class="main">
        <a-card style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Sales Orders</h3>
                <div>
                    <!-- <a-button style="border-raduis:6px; background: #fff;color:#0F3659" icon="plus" class="mr-4">
                        Create Sale Order
                    </a-button> -->
                    <a-button  
                        style="border-raduis:6px; background: #fff;color:#0F3659" icon="export">
                        Export
                    </a-button>
                </div>
            </div>

            <div class="mt-5">
                <div class="card-container">
                    <a-tabs type="card">
                        <a-tab-pane key="1">
                            <span slot="tab">
                                All Orders
                            </span>
                            <div class="requestActions">
                                <!-- <a-form-model
                            :model="orderform"
                        >
                            <a-form-model-item>
                                <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                    <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model> -->
                                <a-button @click="allOrderExportExcel"
                                    style="width:159px; height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                                    icon="export">
                                    Export
                                </a-button>
                                <!-- <a-button @click="showAddNewOrderPage" style="height:38px; border-raduis:5px; background: #ffffff" icon="plus">
                            Request for Inventory
                        </a-button> -->

                            </div>
                            <div>
                                <a-table :columns="columns" :data-source="tableAllOrdersData" :loading="tableLoading"
                                    :pagination="pagination" class="tableStyle">
                                    <div slot="filterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>
                                    <div slot="filterDistributionCenterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>
                                    <div slot="filterStatusDropdown" slot-scope="{ clearFilters }"
                                        style="padding: 8px;display: flex;flex-direction: column;">
                                        <a-select style="width: 190px"
                                            @change="e => onInventoryChange(e, clearFilters)">
                                            <a-select-option value="all">
                                                All
                                            </a-select-option>
                                            <a-select-option value="0">
                                                New
                                            </a-select-option>
                                            <a-select-option value="1">
                                                AwaitingFulfillment
                                            </a-select-option>
                                            <a-select-option value="2">
                                                Fulfilling
                                            </a-select-option>
                                            <a-select-option value="3">
                                                Complete
                                            </a-select-option>
                                            <a-select-option value="4">
                                                Canceled
                                            </a-select-option>
                                            <a-select-option value="5">
                                                Received
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                    <template slot="action" slot-scope="data">
                                        <a-dropdown>
                                            <a style="color:#98c14b;" class="ant-dropdown-link"
                                                @click="e => e.preventDefault()">
                                                <a-icon style="font-size:25px;" type="ellipsis" />
                                            </a>
                                            <a-menu slot="overlay">
                                                <a-menu-item>
                                                    <a @click="showMoreDetails(data)">More Details?</a>
                                                </a-menu-item>
                                                <a-menu-item v-if="showConfirmActions(data)">
                                                    <a @click="showConfrimOrderModal(data)">Confirm this Order?</a>
                                                </a-menu-item>
                                                <a-menu-item v-if="showDeclinedActions(data)">
                                                    <a @click="showDeclinedOrderModal(data)">Decline this Order?</a>
                                                </a-menu-item>
                                                <!-- <a-menu-item>
                                            <a href="javascript:;">View Product Details</a>
                                        </a-menu-item>
                                        <a-menu-item>
                                            <a href="javascript:;">View Inventory Details</a>
                                        </a-menu-item> -->
                                            </a-menu>
                                        </a-dropdown>
                                    </template>
                                    <template slot="status" slot-scope='data'>
                                        <status-component :status="data"></status-component>
                                    </template>
                                </a-table>
                            </div>

                        </a-tab-pane>
                        <a-tab-pane key="2">
                            <span slot="tab">
                                New
                            </span>
                            <div class="requestActions">
                                <!-- <a-form-model
                            :model="orderform"
                        >
                            <a-form-model-item>
                                <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                    <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model> -->
                                <a-button @click="newOrderExportExcel"
                                    style="width:159px; height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                                    icon="export">
                                    Export
                                </a-button>
                            </div>

                            <div>
                                <a-table :columns="columnsStatues" :data-source="tableNewData" :loading="tableLoading"
                                    :pagination="pagination" class="tableStyle">
                                    <div slot="filterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>
                                    <div slot="filterDistributionCenterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>
                                    <template slot="action" slot-scope="data">
                                        <a-dropdown>
                                            <a style="color:#98c14b;" class="ant-dropdown-link"
                                                @click="e => e.preventDefault()">
                                                <a-icon style="font-size:25px;" type="ellipsis" />
                                            </a>
                                            <a-menu slot="overlay">
                                                <a-menu-item>
                                                    <a @click="showMoreDetails(data)">More Detials?</a>
                                                </a-menu-item>
                                                <a-menu-item>
                                                    <a @click="showConfrimOrderModal(data)">Confirm this Order?</a>
                                                </a-menu-item>
                                                <a-menu-item>
                                                    <a @click="showDeclinedOrderModal(data)">Decline this Order?</a>
                                                </a-menu-item>
                                            </a-menu>
                                        </a-dropdown>
                                    </template>

                                    <template slot="status" slot-scope='data'>
                                        <status-component :status="data"></status-component>
                                    </template>
                                </a-table>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane key="3">
                            <span slot="tab">
                                Awaiting Fufillment
                            </span>
                            <div class="requestActions">
                                <!-- <a-form-model
                            :model="orderform"
                        >
                            <a-form-model-item>
                                <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                    <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model> -->
                                <a-button @click="awaitingFufillmentOrderExportExcel"
                                    style="width:159px; height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                                    icon="export">
                                    Export
                                </a-button>
                            </div>
                            <div>
                                <a-table :columns="columnsStatues" :data-source="tableAwaitingFufillmentData"
                                    :loading="tableLoading" :pagination="pagination" class="tableStyle">
                                    <div slot="filterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>
                                    <div slot="filterDistributionCenterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>
                                    <template slot="action" slot-scope="data">
                                        <a-dropdown>
                                            <a style="color:#98c14b;" class="ant-dropdown-link"
                                                @click="e => e.preventDefault()">
                                                <a-icon style="font-size:25px;" type="ellipsis" />
                                            </a>
                                            <a-menu slot="overlay">
                                                <a-menu-item>
                                                    <a @click="showMoreDetails(data)">More Details?</a>
                                                </a-menu-item>
                                                <a-menu-item v-if="showDeclinedActions(data)">
                                                    <a @click="showDeclinedOrderModal(data)">Decline this Order?</a>
                                                </a-menu-item>
                                            </a-menu>
                                        </a-dropdown>
                                    </template>
                                    <template slot="status" slot-scope='data'>
                                        <status-component :status="data"></status-component>
                                    </template>
                                </a-table>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane key="4">
                            <span slot="tab">
                                Shipped Orders
                            </span>
                            <div class="requestActions">
                                <!-- <a-form-model
                            :model="orderform"
                        >
                            <a-form-model-item>
                                <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                    <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model> -->
                                <a-button @click="fufillmentOrderExportExcel"
                                    style="width:159px; height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                                    icon="export">
                                    Export
                                </a-button>
                            </div>
                            <div>
                                <a-table :columns="columnsStatues" :data-source="tableFufillmentData"
                                    :loading="tableLoading" :pagination="pagination" class="tableStyle">
                                    <div slot="filterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>
                                    <div slot="filterDistributionCenterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>
                                    <template slot="action" slot-scope="data">
                                        <a-dropdown>
                                            <a style="color:#98c14b;" class="ant-dropdown-link"
                                                @click="e => e.preventDefault()">
                                                <a-icon style="font-size:25px;" type="ellipsis" />
                                            </a>
                                            <a-menu slot="overlay">
                                                <a-menu-item>
                                                    <a @click="showMoreDetails(data)">More Details?</a>
                                                </a-menu-item>
                                                <a-menu-item v-if="showDeclinedActions(data)">
                                                    <a @click="showDeclinedOrderModal(data)">Decline this Order?</a>
                                                </a-menu-item>
                                            </a-menu>
                                        </a-dropdown>
                                    </template>
                                    <template slot="status" slot-scope='data'>
                                        <status-component :status="data"></status-component>
                                    </template>
                                </a-table>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane key="5">
                            <span slot="tab">
                                Completed
                            </span>
                            <div class="requestActions">
                                <!-- <a-form-model
                            :model="orderform"
                        >
                            <a-form-model-item>
                                <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                    <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model> -->
                                <a-button @click="completetOrderExportExcel"
                                    style="width:159px; height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                                    icon="export">
                                    Export
                                </a-button>
                            </div>
                            <div>
                                <a-table :columns="columnsStatues" :data-source="tableCompletedData"
                                    :loading="tableLoading" :pagination="pagination" class="tableStyle">
                                    <div slot="filterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>
                                    <div slot="filterDistributionCenterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>
                                    <template slot="action" slot-scope="data">
                                        <a-dropdown>
                                            <a style="color:#98c14b;" class="ant-dropdown-link"
                                                @click="e => e.preventDefault()">
                                                <a-icon style="font-size:25px;" type="ellipsis" />
                                            </a>
                                            <a-menu slot="overlay">
                                                <a-menu-item>
                                                    <a @click="showMoreDetails(data)">More Details?</a>
                                                </a-menu-item>
                                            </a-menu>
                                        </a-dropdown>
                                    </template>
                                    <template slot="status" slot-scope='data'>
                                        <status-component :status="data"></status-component>
                                    </template>
                                </a-table>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane key="6">
                            <span slot="tab">
                                Canceled
                            </span>
                            <div class="requestActions">
                                <!-- <a-form-model
                            :model="orderform"
                        >
                            <a-form-model-item>
                                <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                    <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model> -->
                                <a-button @click="cancelOrderExportExcel"
                                    style="width:159px; height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                                    icon="export">
                                    Export
                                </a-button>
                            </div>
                            <div>
                                <a-table :columns="columnsStatues" :data-source="tableCanceledData"
                                    :loading="tableLoading" :pagination="pagination" class="tableStyle">
                                    <div slot="filterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>
                                    <div slot="filterDistributionCenterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px">
                                        <a-input v-ant-ref="c => (searchInput = c)"
                                            :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                        <a-button type="primary" icon="search" size="small"
                                            style="width: 90px; margin-right: 8px"
                                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                            Search
                                        </a-button>
                                        <a-button size="small" style="width: 90px"
                                            @click="() => handleReset(clearFilters)">
                                            Reset
                                        </a-button>
                                    </div>
                                    <template slot="action" slot-scope="data">
                                        <a-dropdown>
                                            <a style="color:#98c14b;" class="ant-dropdown-link"
                                                @click="e => e.preventDefault()">
                                                <a-icon style="font-size:25px;" type="ellipsis" />
                                            </a>
                                            <a-menu slot="overlay">
                                                <a-menu-item>
                                                    <a @click="showMoreDetails(data)">More Details?</a>
                                                </a-menu-item>
                                            </a-menu>
                                        </a-dropdown>
                                    </template>
                                    <template slot="status" slot-scope='data'>
                                        <status-component :status="data"></status-component>
                                    </template>
                                </a-table>
                            </div>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </div>
            <a-modal class="modalStyle" :visible="isConfirmeVisible" :footer="null" @cancel="handleConfirmCancel">
                <h3 style="text-align:center;font-weight: bolder;padding-top: 10px;">Confrim Product Line <span
                        style="color:#418a49">#{{ orderNumber }}</span> ?</h3>
                <div>
                    <a-form-model ref="notesForm" :model="newOrdernotes" :rules="rules">
                        <div>
                            <a-form-model-item label="Reasons:" ref="notes" prop="notes">
                                <a-textarea v-model="newOrdernotes.notes"
                                    placeholder="Kindly give reasons for confirming this order" :rows="4" />
                            </a-form-model-item>
                        </div>
                    </a-form-model>
                </div>

                <div style="display:flex;justify-content: center;padding-bottom: 10px;padding-top:10px">
                    <a-spin class="spinner" :spinning="confirmLoading" />
                </div>
                <div style="display: flex;justify-content: center;">
                    <a-button @click="handleConfirmSubmit" style="background: #418a49;color:#fff;border-radius:5px;">
                        Confirm
                    </a-button>
                    <a-button @click="handleConfirmCancel" style="background: red;color:#fff;border-radius:5px;">
                        Cancel
                    </a-button>
                </div>
            </a-modal>

            <a-modal class="modalStyle" :visible="isDeclinedVisible" :footer="null" @cancel="handleDeclinedCancel">
                <h3 style="text-align:center;font-weight: bolder;padding-top: 10px;">Decline Order <span
                        style="color:#418a49">#{{
                        orderNumber }}</span> ?</h3>
                <div>
                    <p style="font-size:16px;text-align: center;">You are about to decline a new order [ <span
                            style="color:#418a49">#{{ orderNumber }}</span> ].</p>
                </div>

                <div style="display:flex;justify-content: center;padding-bottom: 10px;padding-top:10px">
                    <a-spin class="spinner" :spinning="declineLoading" />
                </div>
                <div style="display: flex;justify-content: center;">
                    <a-button @click="handleDeclinedSubmit" style="background: #418a49;color:#fff;border-radius:5px;">
                        Decline
                    </a-button>
                    <!-- <a-button @click="handleDeclinedCancel" style="background: red;color:#fff;border-radius:5px;">
                    Cancel
                </a-button> -->
                </div>
            </a-modal>
        </a-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import XLSX from "xlsx";
import StatusComponent from '../shared-components/StatusComponent.vue'

const columns = [
    {
        title: 'Order Number',
        // width: 150,
        key: 'orderNumber',
        dataIndex: 'orderNumber',
    },
    {
        title: 'Retailer Name',
        dataIndex: 'retailerName',
        key: 'retailerName',
        scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.retailerName
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        // width: 150,
    },
    {
        title: 'Distribution Center',
        dataIndex: 'distributionCenter',
        scopedSlots: {
            filterDropdown: 'filterDistributionCenterDropdown',
            filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.distributionCenter
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        // width: 200,
    },
    {
        title: 'Amount (Ksh)',
        dataIndex: 'amount',
        key: 'amount',
        //  width: 150,
    },

    {
        title: 'Ordered Date',
        dataIndex: 'dateCreated',
        key: 'dateCreated',
        // width: 150,
    },
    {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        scopedSlots: {
            customRender: "status",
            filterDropdown: 'filterStatusDropdown',
            filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.status
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
    },
    {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
    },
];

const columnsStatues = [
    {
        title: 'Order Number',
        // width: 150,
        key: 'orderNumber',
        dataIndex: 'orderNumber',
    },
    {
        title: 'Retailer Name',
        dataIndex: 'retailerName',
        key: 'retailerName',
        scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.retailerName
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        // width: 150,
    },
    {
        title: 'Distribution Center',
        dataIndex: 'distributionCenter',
        scopedSlots: {
            filterDropdown: 'filterDistributionCenterDropdown',
            filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.distributionCenter
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        // width: 200,
    },
    {
        title: 'Amount (Ksh)',
        dataIndex: 'amount',
        key: 'amount',
        //  width: 150,
    },
    {
        title: 'Date Created',
        dataIndex: 'dateCreated',
        key: 'dateCreated',
        // width: 150,
    },
    {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        scopedSlots: { customRender: 'status' }
    },
    {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
    },
];
export default {
    name: "Orders",
    components: {
        StatusComponent
    },
    data() {
        return {
            orderform: {

            },
            tableAllOrdersData: [],
            tableAwaitingFufillmentData: [],
            tableCompletedData: [],
            tableNewData: [],
            tableCanceledData: [],
            tableFufillmentData: [],
            tableLoading: false,
            confirmLoading: false,
            declineLoading: false,
            isConfirmeVisible: false,
            isDeclinedVisible: false,
            availableOrders: [],
            orderNumber: "",
            searchText: "",
            searchInput: null,
            searchedColumn: '',
            pagination: {
                pageSize: 20
            },
            newOrdernotes: {
                notes: ''
            },
            newOrderDetails: '',
            columns,
            columnsStatues,
            rules: {
                notes: [
                    { required: true, message: 'Please this field cannot be empty', trigger: 'change' },
                ],

            }
        }
    },
    methods: {
        ...mapActions(['getAgentAllOrderRequests', 'setOrderInfo', 'confirmNewOrder', 'declineNewOrder']),
        showAddNewOrderPage() {
            this.$router.push('/request-product').catch(() => { });
        },
        showOrderDetailsPage() {

        },
        handleSearch(selectedKeys, confirm, dataIndex) {
            confirm();
            this.searchText = selectedKeys[0];
            this.searchedColumn = dataIndex;
        },
        handleReset(clearFilters) {
            clearFilters();
            this.searchText = '';
        },
        onInventoryChange(value, clearFilters) {
            let result = []
            if (value === 'all') {
                result = this.availableOrders
            } else {
                result = this.availableOrders.filter(invoice => parseInt(invoice.status) === parseInt(value))
            }
            let finalOrderRequestList = result.map(order => ({
                key: order.id,
                orderNumber: `#${order.id}`,
                distributionCenter: order.sourceLocationName,
                retailerName: order.destinationLocationName,
                customerName: order.destinationLocationName,
                amount: order.total ? order.total.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '0.00',
                dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
                status: order.statusLabel,
                action: order
            }));
            this.tableAllOrdersData = _.orderBy(finalOrderRequestList, ['key'], ['desc'])
            clearFilters();
        },
        redirectUrl() {
            this.$router.push('/view-orders').catch(() => { });
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        showConfrimOrderModal(data) {
            this.isConfirmeVisible = true
            // console.log("order data | ", data)
            this.orderNumber = data.id
            this.newOrderDetails = data
        },
        showDeclinedOrderModal(data) {
            this.isDeclinedVisible = true
            this.orderNumber = data.id
            this.newOrderDetails = data
        },
        handleConfirmSubmit() {
            this.$refs.notesForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true
                    // console.log("order data | ", this.newOrderDetails)
                    let request = {
                        inventoryRequestId: this.newOrderDetails.id,
                        reasons: {
                            notes: this.newOrdernotes.notes
                        }
                    }
                    // console.log("request | ", request)
                    this.confirmNewOrder(request).then(response => {
                        this.confirmLoading = false;
                        if (response.status === 200) {
                            this.allOrders()
                            this.isConfirmeVisible = false
                            this.showSuccessAlert(`New Order [ #${this.newOrderDetails.id} ] Confirmed Successfully`)
                            this.$refs.notesForm.resetFields();
                        } else {
                            this.showErrorAlert(response.data.messages)
                        }
                    }, error => {
                        this.confirmLoading = false
                        console.error("Error | ", error)
                        this.showErrorAlert('Something went wrong, try again later.')
                    })
                } else {
                    return false;
                }
            })
        },
        handleDeclinedSubmit() {
            this.declineLoading = true
            // console.log("order data | ", this.newOrderDetails)
            let request = {
                inventoryRequestId: this.newOrderDetails.id,
                data: {
                    status: 4
                }
            }
            // console.log("request | ", request)
            this.declineNewOrder(request).then(response => {
                this.declineLoading = false;
                if (response.status === 200) {
                    this.allOrders()
                    this.isDeclinedVisible = false
                    this.showSuccessAlert(`New Order [ #${this.newOrderDetails.id} ] Declined Successfully`)
                } else {
                    this.showErrorAlert(response.data.messages)
                }
            }, error => {
                this.declineLoading = false
                console.error("Error | ", error)
                this.showErrorAlert('Something went wrong, try again later.')
            })
        },
        handleConfirmCancel() {
            this.isConfirmeVisible = false
        },
        handleDeclinedCancel() {
            this.isDeclinedVisible = false
        },
        showMoreDetails(data) {
            this.setOrderInfo(data)
            this.$router.push('/order-details').catch(() => { });
        },
        getAllOrderData(data) {
            // console.log("Data | ", data)
            let finalOrderRequestList = [];

            data.forEach(request => {

                let orderRquestObject = {}
                orderRquestObject['key'] = request.id
                orderRquestObject['orderNumber'] = `#${request.id}`
                orderRquestObject['distributionCenter'] = request.sourceLocationName
                orderRquestObject['retailerName'] = request.destinationLocationName
                orderRquestObject['customerName'] = request.destinationLocationName
                orderRquestObject['amount'] = request.total ? request.total.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '0.00'
                orderRquestObject['dateCreated'] = moment(request.createdAt).format("DD-MMM-YYYY");
                orderRquestObject['status'] = request.statusLabel
                orderRquestObject['action'] = request

                finalOrderRequestList.push(orderRquestObject)

            })
            this.tableAllOrdersData = _.orderBy(finalOrderRequestList, ['key'], ['desc'])
        },
        getAllAwaitingFufillingData(data) {
            let finalAwaitingFufillmentList = [];

            data.forEach(request => {
                if (request.statusLabel === "AwaitingFulfillment") {
                    let awaitingFufillObject = {}
                    awaitingFufillObject['key'] = request.id
                    awaitingFufillObject['orderNumber'] = `#${request.id}`
                    awaitingFufillObject['distributionCenter'] = request.sourceLocationName,
                        awaitingFufillObject['retailerName'] = request.destinationLocationName,
                        awaitingFufillObject['customerName'] = request.destinationLocationName
                    awaitingFufillObject['status'] = request.statusLabel
                    awaitingFufillObject['amount'] = request.total ? request.total.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '0.00'
                    awaitingFufillObject['dateCreated'] = moment(request.createdAt).format("DD-MM-YYYY HH:mm:ss A");
                    awaitingFufillObject['action'] = request

                    finalAwaitingFufillmentList.push(awaitingFufillObject)
                }
            })
            this.tableAwaitingFufillmentData = _.orderBy(finalAwaitingFufillmentList, ['key'], ['desc'])
            // console.log('tableAwaitingFufillmentData | ', this.tableAwaitingFufillmentData)
        },
        getAllFufillingData(data) {
            let finalFufillmentList = [];

            data.forEach(request => {
                if (request.statusLabel === "Fulfilling") {
                    let fufillObject = {}
                    fufillObject['key'] = request.id
                    fufillObject['orderNumber'] = `#${request.id}`
                    fufillObject['distributionCenter'] = request.sourceLocationName
                    fufillObject['retailerName'] = request.destinationLocationName
                    fufillObject['status'] = request.statusLabel
                    fufillObject['amount'] = request.total ? request.total.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '0.00'
                    fufillObject['dateCreated'] = moment(request.createdAt).format("DD/MM/YYYY HH:mm:ss A");
                    fufillObject['action'] = request

                    finalFufillmentList.push(fufillObject)
                }
            })
            this.tableFufillmentData = _.orderBy(finalFufillmentList, ['key'], ['desc'])
            // console.log('tableAwaitingFufillmentData | ', this.tableAwaitingFufillmentData)
        },
        getAllCompletedData(data) {
            let finalCompletedList = [];

            data.forEach(request => {
                if (request.statusLabel === "Complete") {
                    let completedObject = {}
                    completedObject['key'] = request.id
                    completedObject['orderNumber'] = `#${request.id}`
                    completedObject['distributionCenter'] = request.sourceLocationName
                    completedObject['retailerName'] = request.destinationLocationName
                    completedObject['status'] = request.statusLabel
                    completedObject['amount'] = request.total ? request.total.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '0.00'
                    completedObject['dateCreated'] = moment(request.createdAt).format("DD/MM/YYYY HH:mm:ss A");
                    completedObject['action'] = request

                    finalCompletedList.push(completedObject)
                }
            })
            this.tableCompletedData = _.orderBy(finalCompletedList, ['key'], ['desc'])
            // console.log('tableAwaitingFufillmentData | ', this.tableAwaitingFufillmentData)
        },

        getAllNewData(data) {
            let finalNewList = [];

            data.forEach(request => {
                if (request.statusLabel === "New") {
                    let newObject = {}
                    newObject['key'] = request.id
                    newObject['orderNumber'] = `#${request.id}`
                    newObject['distributionCenter'] = request.sourceLocationName
                    newObject['retailerName'] = request.destinationLocationName
                    newObject['status'] = request.statusLabel
                    newObject['amount'] = request.total ? request.total.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '0.00'
                    newObject['dateCreated'] = moment(request.createdAt).format("DD/MM/YYYY HH:mm:ss A");
                    newObject['action'] = request

                    finalNewList.push(newObject)
                }
            })
            this.tableNewData = _.orderBy(finalNewList, ['key'], ['desc'])
            // console.log('tableAwaitingFufillmentData | ', this.tableAwaitingFufillmentData)
        },
        getAllCancelledData(data) {
            let finalCancelledList = [];

            data.forEach(request => {
                if (request.statusLabel === "Canceled") {
                    let cancelledObject = {}
                    cancelledObject['key'] = request.id
                    cancelledObject['orderNumber'] = `#${request.id}`
                    cancelledObject['distributionCenter'] = request.sourceLocationName
                    cancelledObject['retailerName'] = request.destinationLocationName
                    cancelledObject['status'] = request.statusLabel
                    cancelledObject['amount'] = request.total ? request.total.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '0.00'
                    cancelledObject['dateCreated'] = moment(request.createdAt).format("DD/MM/YYYY HH:mm:ss A");
                    cancelledObject['action'] = request

                    finalCancelledList.push(cancelledObject)
                }
            })
            this.tableCanceledData = _.orderBy(finalCancelledList, ['key'], ['desc'])
            // console.log('tableAwaitingFufillmentData | ', this.tableAwaitingFufillmentData)
        },
        allOrderExportExcel() {
            // console.log("tableAllOrdersData | ", this.tableAllOrdersData)
            const dataToExport = [
                [
                    "Order Number",
                    "Retailer Name",
                    "Amount(Ksh)",
                    "Distribution Centre Name",
                    "Ordered Date",
                    "Status"
                ],
            ];
            this.tableAllOrdersData.forEach((v) => {
                dataToExport.push([
                    v.orderNumber,
                    v.action.destinationLocationName,
                    v.amount,
                    v.action.sourceLocationName,
                    v.dateCreated,
                    v.status
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-All-Orders-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },
        newOrderExportExcel() {
            // console.log("tableNewData | ", this.tableNewData)
            const dataToExport = [
                [
                    "Order Number",
                    "Retailer Name",
                    "Amount(Ksh)",
                    "Distribution Centre Name",
                    "Ordered Date",
                    "Status"
                ],
            ];
            this.tableNewData.forEach((v) => {
                dataToExport.push([
                    v.orderNumber,
                    v.action.destinationLocationName,
                    v.amount,
                    v.action.sourceLocationName,
                    v.dateCreated,
                    v.status
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-New-Orders-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },
        awaitingFufillmentOrderExportExcel() {
            // console.log("tableAwaitingFufillmentData | ", this.tableAwaitingFufillmentData)
            const dataToExport = [
                [
                    "Order Number",
                    "Retailer Name",
                    "Amount(Ksh)",
                    "Distribution Centre Name",
                    "Ordered Date",
                    "Status"
                ],
            ];
            this.tableAwaitingFufillmentData.forEach((v) => {
                dataToExport.push([
                    v.orderNumber,
                    v.action.destinationLocationName,
                    v.amount,
                    v.action.sourceLocationName,
                    v.dateCreated,
                    v.status
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Awaiting-Fufillment-Orders-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },
        fufillmentOrderExportExcel() {
            // console.log("tableFufillmentData | ", this.tableFufillmentData)
            const dataToExport = [
                [
                    "Order Number",
                    "Retailer Name",
                    "Amount(Ksh)",
                    "Distribution Centre Name",
                    "Ordered Date",
                    "Status"
                ],
            ];
            this.tableFufillmentData.forEach((v) => {
                dataToExport.push([
                    v.orderNumber,
                    v.action.destinationLocationName,
                    v.amount,
                    v.action.sourceLocationName,
                    v.dateCreated,
                    v.status
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Fufillment-Orders-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },
        completetOrderExportExcel() {
            // console.log("tableCompletedData | ", this.tableCompletedData)
            const dataToExport = [
                [
                    "Order Number",
                    "Retailer Name",
                    "Amount(Ksh)",
                    "Distribution Centre Name",
                    "Ordered Date",
                    "Status"
                ],
            ];
            this.tableCompletedData.forEach((v) => {
                dataToExport.push([
                    v.orderNumber,
                    v.action.destinationLocationName,
                    v.amount,
                    v.action.sourceLocationName,
                    v.dateCreated,
                    v.status
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Complete-Orders-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },
        cancelOrderExportExcel() {
            // console.log("tableCanceledData | ", this.tableCanceledData)

            const dataToExport = [
                [
                    "Order Number",
                    "Retailer Name",
                    "Amount(Ksh)",
                    "Distribution Centre Name",
                    "Ordered Date",
                    "Status"
                ],
            ];
            this.tableCanceledData.forEach((v) => {
                dataToExport.push([
                    v.orderNumber,
                    v.action.destinationLocationName,
                    v.amount,
                    v.action.sourceLocationName,
                    v.dateCreated,
                    v.status
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Cancel-Orders-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },
        allOrders() {
            this.tableLoading = true;
            this.getAgentAllOrderRequests().then(response => {
                this.tableLoading = false;
                // console.log('response order | ', response)
                if (response.status === 200) {
                    let result = []
                    if (response.data.data.length !== 0) {
                        result = response.data.data;
                        this.availableOrders = response.data.data;
                    }
                    this.getAllOrderData(result)
                    this.getAllAwaitingFufillingData(result)
                    this.getAllCompletedData(result)
                    this.getAllNewData(result)
                    this.getAllCancelledData(result)
                    this.getAllFufillingData(result)
                } else {
                    this.tableLoading = false;
                    console.log('Error | ', response)
                }

            },
                error => {
                    this.tableLoading = false;
                    console.log('Error | ', error)
                })
        },
        showConfirmActions(data) {
            const result = data.statusLabel === 'New' ? true : false
            return result
        },
        showDeclinedActions(data) {
            const allowedDeclincedStatus = ['New', 'AwaitingFulfillment', 'Fulfilling']
            const result = allowedDeclincedStatus.includes(data.statusLabel) ? true : false
            return result
        }
    },
    computed: {
        displayTotalOrders() {
            return this.tableAllOrdersData.length
        },
        displayTotalNewOrders() {
            return this.tableNewData.length
        },
        displayTotalAwaitFufillmentOrders() {
            return this.tableAwaitingFufillmentData.length
        },
        displayTotalFulfillment() {
            return this.tableFufillmentData.length
        },
        displayTotalComplete() {
            return this.tableCompletedData.length
        },
        displayTotalCancel() {
            return this.tableCanceledData.length
        }

    },
    created() {
        if (this.allOrders) {
            this.allOrders()
        }
    }
}
</script>

<style scoped>
.requestActions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.card-container {
    background: none;
    overflow: hidden;
    /* padding: 24px; */
}

.card-container>.ant-tabs-card>.ant-tabs-content {
    height: 120px;
    margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
    background: #fff;
    padding: 16px;

}

.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}

.card-container>>>.ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}

.card-container>>>.ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.modalStyle>>>.ant-modal-header {
    border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
    border-top: none;
}

.modalStyle {
    display: flex;
    justify-content: center;
}

.card-container>>>.ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

.spinner>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.card-container>.ant-tabs-card>.ant-tabs-bar {
    border-color: #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
    border-color: transparent;
    background: transparent;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
    border-color: #e5efe7;
    background: #e5efe7;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

button:hover {
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

.orderTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.orderTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.orderTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.orderTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}

.card-container>>>.ant-tabs-card>.ant-tabs-bar {
    border: none;
}

.card-container>>>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
    height: 40px;
    color: #111827;
    background: transparent;
    border-radius: 8px;
    max-width: 12%;
    margin-right: 12px;
}


.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #fff;
    background: #418a49;
    border-bottom: none;
    border-radius: 8px;
    max-width: 12%;
}
</style>